module.exports = __webpack_public_path__ + "img/g4.0c0f85c1.png";